import styles from './MCCAItem.module.css'
interface IMCCAUnit
{
    name: string
    id:number
    selected: boolean
    onClick: (id:number)=>void
}
export default function MCCAUnit({selected,onClick,name, id}:IMCCAUnit){
    return(
        <div className={[styles.uCont, selected ? styles.sel : ""].join(' ')} onClick={()=>onClick(id)}>
            <input type={"checkbox"} checked={selected} readOnly={true}/>
            <div>{name}</div>
        </div>
    )
}